import './blog.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initTemplateBlog = (context) => {
  const templateBlogSection = context.closest('.shopify-section');
  if (!templateBlogSection) return;

  const content = templateBlogSection.querySelector('.blog__container');
  const filtersWrapper = templateBlogSection.querySelector(
    '.blog__tags-container--desktop',
  );
  if (!content) return;
  content.classList.add('blog__container--initialized');

  if (!filtersWrapper) return;

  // Manage tags mobile dropdown
  content.addEventListener('click', (e) => {
    const tagsOpener = e.target.closest('.blog__tags-trigger');
    if (!tagsOpener) return;
    const tagsContainerMobile = content.querySelector('.blog__tags-container--mobile');
    if (tagsContainerMobile) {
      const tags = tagsContainerMobile.querySelectorAll('.blog__tag');
      if (tags) {
        if (tagsOpener.classList.contains('open')) {
          tagsOpener.classList.remove('open');
        } else {
          tagsOpener.classList.add('open');
        }
        if (tagsContainerMobile.classList.contains('open')) {
          tagsContainerMobile.classList.remove('open');
        } else {
          tagsContainerMobile.classList.add('open');
        }

        tags.forEach(tag => {
          tag.addEventListener('click', ()=> {
            tagsContainerMobile.classList.remove('open');
          });
        });
      }
    }
  });

  // Manage desktop tags
  content.addEventListener('click', (e) => {
      const filter = e.target.closest('.blog__tag a[href]');
      if (!filter) return;
      e.preventDefault();
      if (!filter.href) return;
      filter.blur();
      content.classList.add('loading');
      content.classList.remove('blog__container--initialized');
      fetch(filter.href)
        .then((res) => {
          if (!res.ok) {
            content.classList.remove('loading');
            content.classList.add('blog__container--initialized');
            var error = new Error(response.status);
            throw error;
          }

          return res.text();
        })
        .then((text) => {
          const newPage = new DOMParser().parseFromString(text, 'text/html');
          const newContent = newPage.querySelector('.blog__container');
          if (!newContent) {
            content.classList.remove('loading');
            content.classList.add('blog__container--initialized');
            return;
          }
          content.innerHTML = newContent.innerHTML;
          history.pushState(null, '', filter.href);


          const ajaxinateContainer = document.querySelector(
            '.blog__articles--ajaxinate',
          );
          const ajaxinatePagination = document.querySelector(
            '.blog__pagination--ajaxinate',
          );
          const elementsCounter = document.querySelector(
            '.blog__footer [data-counter]',
          );
          if (
            ajaxinateContainer &&
            ajaxinatePagination &&
            typeof window.Ajaxinate !== 'undefined'
          ) {
            new Ajaxinate({
              container: '.blog__articles--ajaxinate',
              pagination: '.blog__pagination--ajaxinate',
              method: 'click',
              callback: function (requestURL) {
                window.dAgency.ajaxinateCallBack(
                  requestURL,
                  '.blog__articles--ajaxinate',
                );
                if (elementsCounter) {
                  elementsCounter.innerText =
                    ajaxinateContainer.querySelectorAll('.editorial-tile').length;
                }
              },
            });
          }

          content.classList.remove('loading');
          content.classList.add('blog__container--initialized');
        });
  });
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.blog'), (el) => {
    window.dAgency.initTemplateBlog(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.blog'), (el) => {
      window.dAgency.initTemplateBlog(el);
    });
  });
}
